import React from "react";

import { type QuestionRendererPropsBase } from "features/Library/Common/props";
import { QuestionsMap } from "features/Library/Assessments/Details/AssessmentContentForm/AssessmentProviders/QuestionsMap";
import { type IQuestion } from "features/Library/Common/models";
import { type AssessmentQuestionType } from "features/Library/Assessments/types/state";

export type QuestionBuilderProps<T> = QuestionRendererPropsBase<IQuestion<T>, T>;

export const AssessmentQuestionBuilder = <T,>(props: QuestionBuilderProps<T>) => {
  const { question, validatedFieldProps, index, onBlur, onChanged, disabled, propertyNamePrefix } = props;
  const { Component } = QuestionsMap[question.questionType as AssessmentQuestionType];
  return (
    <Component
      disabled={disabled}
      index={index}
      onBlur={onBlur}
      onChanged={onChanged}
      question={question.question as any}
      validatedFieldProps={validatedFieldProps}
      propertyNamePrefix={propertyNamePrefix}
    />
  );
};
